import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './header.i18n';
import LanguageSelectionDropdown from '../../containers/LanguageSelectionDropdown/LanguageSelectionDropdown';
import Message from '../../containers/Message/Message';

class Header extends React.Component {
  onMessageBarDismissed = () => {
    this.title.focus();
  }

  setTitle = (h1) => {
    this.title = h1;
  };

  renderMessageDisplay() {
    if (this.props.hasMessageDisplay) {
      return <Message onDismissed={this.onMessageBarDismissed} />;
    }
    return null;
  }

  renderTitleDescription() {
    if (this.props.titleDescription) {
      return (
      <div className="understated ar-identifier" tabIndex={0}>
        {this.props.titleDescription}
      </div>);
    }

    return null;
  }

  render() {
    const {
      hasLanguageDropdown,
      headerTitle,
      ariaDescribedby,
      badgeNumber,
    } = this.props;

    const divStyle = { float: 'left', width: '100%' };
    const headerStyle = { float: 'left' };

    return (
      <div style={divStyle}>
        {this.renderMessageDisplay()}
        {
            hasLanguageDropdown !== undefined
            && hasLanguageDropdown !== null
            && hasLanguageDropdown === true ?
            <LanguageSelectionDropdown /> :
              null
        }
        {
          headerTitle ?
            <h1 className="header" id="content" data-qa-item="pageHeader"
              aria-describedby={ariaDescribedby} tabIndex="0"
              ref={this.setTitle} style={headerStyle}
            >
              <span className="title" >
                {headerTitle }
              </span>
              {
                badgeNumber !== undefined
                && badgeNumber !== null
                && badgeNumber > 0 ?
                  <div className="header-new-badge">
                    <span className="badge">{badgeNumber}</span>
                    <span className="header-new">
                      <FormattedMessage {...messages.labels.newIndicator} />
                    </span>
                  </div>
                  : null
              }
            </h1> :
            <span id="content"></span>
        }
        {this.renderTitleDescription()}
      </div>
    );
  }
}

Header.propTypes = {
  headerTitle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  badgeNumber: PropTypes.number,
  ariaDescribedby: PropTypes.string,
  hasMessageDisplay: PropTypes.bool,
  hasLanguageDropdown: PropTypes.bool,
  titleDescription: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
};

export default Header;
